import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { ApplianceDetailsQuery } from './state/appliance-details.query';
import { ApplianceDetailsVisibilityService } from './appliance-visibility.service';
import { ApplianceTypeEnums } from './models/appliance-type.enum';
import { ApplianceDetailsState } from './state/appliance-details.store';
import { enumEquals } from '@shared/utils/enum-utils';

@Injectable({ providedIn: 'root' })
export class ApplianceDetailsDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly query: ApplianceDetailsQuery,
		private readonly visibilityService: ApplianceDetailsVisibilityService
	) {}

	static hasApplianceType(s: ApplianceDetailsState): boolean {
		return !!s.applianceType.Id && !enumEquals(s.applianceType.Id, ApplianceTypeEnums.Empty);
	}

	static hasUpperLower(s: ApplianceDetailsState): boolean {
		return s.isUpperChecked || s.isLowerChecked;
	}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		return this.visibilityService.fieldsFor$(targetTemplate, targetProcedureMap).pipe(
			withLatestFrom(this.visibilityService.fields$, this.visibilityService.isSectionVisible$),
			map(([tgt, cur, isVisible]) => {
				if (!isVisible) {
					return false;
				}

				const s = this.query.getValue();

				return (
					(cur.applianceType && !tgt.applianceType && ApplianceDetailsDirtyCheckService.hasApplianceType(s)) ||
					(cur.upperLowerCard && !tgt.upperLowerCard && ApplianceDetailsDirtyCheckService.hasUpperLower(s))
				);
			})
		);
	}
}
